import { api, download } from "../helpers";

export const getList = (payload, token) =>
	api("/shops", "GET", undefined, payload, token);

export const getDetail = ({ id }, token) =>
	api("/shops/" + id, "GET", undefined, undefined, token);

export const updateStatus = ({ id, ...payload }, token) =>
	api("/shops/" + id + "/status", "PUT", payload, {}, token);

export const exportShops = (params, token) =>
	download("/shops/export", params, token);
